export enum Role {
    Printer = 'Printer',
    Admin = 'Admin',
    Shop='Shop',
    Designer='Designer',
    Public='Public'
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_models/role.ts